import React, { Component, Fragment } from 'react';
import FormField from './../FormField';
import PropTypes from 'prop-types';
import styles from './TagsFieldset.scss';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { bindActionCreators } from 'redux';
import {Button} from 'reactstrap';
import TitleHeader from '../../TitleHeader';
import InfoLink from '../../InfoLink';

class TagsFieldset extends Component {
    static propTypes = {
      tags: PropTypes.array.isRequired,
      new_tag: PropTypes.string
    };

    state =  {
      showTags: false
    }

    componentDidMount() {
      if (this.props.tags.length > 0){
        this.setState({
          showTags: true
        });
      }
    }

    componentDidUpdate(prevProps) {
      if (this.props.new_tag !== prevProps.new_tag){
        this.props.change('eventSubmission', 'new_tag', this.sliceTag(this.props.new_tag));
      }
    }

  addTag = () => {
    const newTagValue = this.props.new_tag || '';
    let newTag = newTagValue.trim().replace(/\s/g, '');
    if (!newTag) return;

    this.props.change('eventSubmission', 'tags', [...this.props.tags, newTag]);
    this.props.change('eventSubmission', 'new_tag', '');

    this.setState({
      newTagValue: '',
      showTags: true
    });
  }

  removeTag(index) {
    let formTags = this.props.tags.slice();
    formTags.splice(index, 1);
    this.props.change('eventSubmission', 'tags', formTags);
  }

  sliceTag(tag){
    let slicedTag = tag || '';
    return slicedTag.slice(0, 30);
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.addTag();
    }
  };

  render() {
    const showTags = this.state.showTags;
    const currentTags = this.props.tags;
    const limitReached = currentTags.length >= 15;

    return (
      <Fragment>
        <TitleHeader title="Tags / Keywords">
          <InfoLink link="https://support.evvnt.com/hc/en-us/articles/360020370640"/>
        </TitleHeader>
        <div className={`card-body ${styles.TagsFieldset}`}>
          <div className="row">
            <div className="col-md-8">
              <FormField
                name="new_tag"
                component="input"
                type="text"
                maxLength={30}
                className="form-control"
                placeholder="Add keywords to your event..."
                inputProps={{ onKeyPress: this.handleKeyPress }}
              />
            </div>
            <div className="col-md-4">
              <Button color="info" disabled={limitReached} onClick={() => this.addTag()}>
                + Add
              </Button>
            </div>
          </div>
          {showTags && <div className={'row ' + styles.childrenRow}>
            <div className="col-md-8">
              <div className="tags">
                <ul>
                  {currentTags.map((tag, i) => (
                    <li key={tag + i} className="tag">
                      {tag}
                      <a onClick={() => this.removeTag(i)} className={styles.removeLink} target="_blank">
                        <i className="fa fa-times" />
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          }
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  new_tag: state.form.eventSubmission.values.new_tag,
  tags:  state.form.eventSubmission.values.tags,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ change }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TagsFieldset);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/TagsFieldset.jsx